export default "__VITE_ASSET__BBFwHvW9__"